import axios from "axios";
import { BadgeCheck, Headphones, Lock, Truck } from "lucide-react";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/customer/cart/Cart.css";
import CartItem from "../../../components/customer/cart/CartItem";
import CartSummary from "../../../components/customer/cart/CartSummary";
import MyNavbar from "../../../components/customer/navigationbar/MyNavbar";
import AppContext from "../../../context/AppContext";
import Footer from "../../../subscreen/customer/footer/Footer";

const Cart = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken, loggedInCustomer } = useContext(AppContext);

  // ── States ────────────────────────────────────────────
  const [cartItems, setCartItems] = useState([]);

  // ── viewCart
  const viewCart = () => {
    console.log("viewCart called!");
    const formData = new FormData();
    formData.append("adcustomer_id", loggedInCustomer?.id);

    axios
      .post(`${baseUrl}/customer/cart/viewCart`, formData, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        console.log(response.data);
        setCartItems(response.data.cart);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewCart();
  }, []);

  const clearCart = () => {
    if (window.confirm("Clear all cart items?")) {
      axios
        .post(`${baseUrl}/customer/cart/clearCart`)
        .then((response) => {
          console.log(response.data);
          setCartItems([]);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handleContinueShopping = () => navigate("/products");

  const handleCheckout = () => {
    navigate("/checkout", {
      state: {
        cartItems: cartItems, // all cart items
        totalAmount: "7,000",
      },
    });
  };

  return (
    <div className="cart-page">
      <MyNavbar />

      <header className="cart-header">
        <div className="cart-header-content">
          <button className="back-btn" onClick={handleContinueShopping}>
            ← Back to Shop
          </button>
          <h1 className="cart-title">Shopping Cart</h1>
          <div className="cart-count-badge">
            {cartItems?.length} {cartItems?.length === 1 ? "Item" : "Items"}
          </div>
        </div>
      </header>

      <div className="cart-container">
        {cartItems?.length === 0 ? (
          // ── Empty Cart ──────────────────────────────────
          <div className="empty-cart">
            <div className="empty-cart-icon">🛒</div>
            <h2>Your Cart is Empty</h2>
            <p>Looks like you haven't added any items yet.</p>
            <button
              className="continue-shopping-btn"
              onClick={handleContinueShopping}
            >
              Start Shopping
            </button>
          </div>
        ) : (
          // ── Cart Items ──────────────────────────────────
          <div className="cart-content">
            <div className="cart-items-section">
              <div className="cart-items-header">
                <h2>Cart Items</h2>
                <button className="clear-cart-btn" onClick={clearCart}>
                  Clear Cart
                </button>
              </div>

              <div className="cart-items-list">
                {cartItems?.map((item) => (
                  <CartItem
                    key={item.id}
                    item={item}
                    viewCart={viewCart}
                    onRefresh={() => viewCart()}
                  />
                ))}
              </div>

              <button
                className="continue-link"
                onClick={handleContinueShopping}
              >
                ← Continue Shopping
              </button>
            </div>

            <div className="cart-summary-section">
              <CartSummary
                onCheckout={handleCheckout}
                selectedItems={cartItems}
              />
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Cart;
